import { Link } from "react-router-dom";
import { TermsContent } from "@/components/TermsContent";
import { Sparkles, ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12 sm:px-10">
      <div className="mb-8 flex items-center gap-2.5">
        <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary">
          <Sparkles className="h-5 w-5 text-primary-foreground" />
        </div>
        <div>
          <div className="font-display text-2xl font-extrabold leading-none">KlenaPro</div>
          <div className="label-caps text-muted-foreground">Legal</div>
        </div>
      </div>
      <h1 className="font-display text-3xl font-extrabold sm:text-4xl">Terms &amp; Conditions</h1>
      <div className="mt-6">
        <TermsContent />
      </div>
      <Link
        to="/login"
        data-testid="terms-back-link"
        className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-foreground underline underline-offset-4"
      >
        <ArrowLeft className="h-4 w-4" /> Back to sign in
      </Link>
    </div>
  );
}
